import { useOnChange } from "@prismicio/editor-support/React"
import {
  Box,
  Dialog,
  DialogActionButton,
  DialogActions,
  DialogContent,
  DialogHeader,
} from "@prismicio/editor-ui"

import { RefineSlice, useRefineSlice } from "../aiSlices"
import type { VisualSharedSlice } from "../sliceTableData"

interface RefineSliceDialogProps {
  initialSlice?: VisualSharedSlice
  onFinish: (args?: { promptId: string; slice: VisualSharedSlice }) => void
}

export function RefineSliceDialog(props: RefineSliceDialogProps) {
  const { initialSlice, onFinish } = props

  function onOpenChange(open: boolean) {
    if (!open) onFinish(undefined)
  }

  const refineSlice = useRefineSlice()

  const open = Boolean(initialSlice)
  useOnChange(open, () => {
    if (initialSlice) refineSlice.init({ slice: initialSlice })
    else refineSlice.clear()
  })

  function onOk() {
    const { selectedVersion: { promptId, slice } = {} } = refineSlice
    // If there's no promptId, the slice is the original one.
    onFinish(promptId && slice ? { promptId, slice } : undefined)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange} noDescription>
      <DialogHeader icon="autoFixHigh" title="Iterate on the slice" />
      <DialogContent>
        <Box
          overflowY="auto"
          flexGrow={1}
          padding={24}
          flexDirection="column"
          gap={12}
        >
          <RefineSlice {...refineSlice} />
        </Box>
      </DialogContent>
      {refineSlice.simulatorUrl && (
        <DialogActions>
          <DialogActionButton onClick={onOk}>Use this slice</DialogActionButton>
        </DialogActions>
      )}
    </Dialog>
  )
}
